import React from 'react';
import styled from 'styled-components';

function Section({ title, description , leftBtnText, rightBtnText, backgroundImg}) {
  return <Wrap bgImage={backgroundImg}>
       <ItemText>
           <h1>{ title }</h1>
           <p>{ description }</p>
       </ItemText>
       <Buttons>
       <ButtonGroup>
          {leftBtnText && <LeftButton>{leftBtnText}</LeftButton>}
          {rightBtnText && <RightButton>{rightBtnText}</RightButton>}
       </ButtonGroup>
       </Buttons>
  </Wrap>
}

export default Section;

const Wrap = styled.div`
   width: 100vw;
   height: 100vh;
   background-size: cover;
   background-position: center;
   background-repeat: no-repeat;
   background-image: url('/image/20220203_103617.jpg');
   display: flex;
   flex-direction: column;
   justify-content: space-between; // vertical
   align-items: center; // horizontal
   background-image: ${props => `url("/image/${props.bgImage}")`};
   textColor: ${props => props.textColor};
`

const ItemText = styled.div`
    padding-top: 15vh;
    text-align: center;
    animation: animateDown infinite 1.5s;
`

const ButtonGroup = styled.div`
   display: flex;
   margin-bottom: 30px;
   @media (max-width: 768px) {
      flex-direction: column;
   }
`

const LeftButton = styled.div`
   background-color: rgba(23,26,32,0.8);
   height: 40px;
   width: 256px;
   color: green;
   display: flex;
   justify-content: center;
   align-items: center;
   border-radius: 100px;
   opacity: 1;
   text-transform: uppercase;
   font-size: 20px;
   cursor: pointer;
   animation: animateDown infinite 1.5s;

`

const RightButton = styled(LeftButton)`
     background: white;
     opcaity: 1;
     color: green;
     animation: animateDown infinite 1.5s;

`

const Buttons = styled.div`

`
